// Client side of PdfRoutes.php. The request body is *inputs only* (see
// buildPdfInput() in component.js) — the server recomputes every result
// itself, so nothing here needs to send results along.

// RFC 4122 v4 — PdfRoutes.php only accepts that exact format.
export const createUuid = () => {
	if ( window.crypto?.randomUUID ) {
		return window.crypto.randomUUID();
	}

	const bytes = window.crypto.getRandomValues( new Uint8Array( 16 ) );
	// Version (4) and variant bits, as randomUUID() would set them.
	/* eslint-disable no-bitwise */
	bytes[ 6 ] = ( bytes[ 6 ] & 0x0f ) | 0x40;
	bytes[ 8 ] = ( bytes[ 8 ] & 0x3f ) | 0x80;
	/* eslint-enable no-bitwise */
	const hex = Array.from( bytes, ( byte ) =>
		byte.toString( 16 ).padStart( 2, '0' )
	).join( '' );

	return `${ hex.slice( 0, 8 ) }-${ hex.slice( 8, 12 ) }-${ hex.slice(
		12,
		16
	) }-${ hex.slice( 16, 20 ) }-${ hex.slice( 20 ) }`;
};

export const storedPdfUrl = ( pdfSettings, id ) =>
	`${ pdfSettings.storageUrl }${ id }.pdf`;

const postJson = ( url, body ) =>
	window.fetch( url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify( body ),
	} );

// Stores the PDF under the URL already sent to HubSpot. Retried once: the
// link in HubSpot/Salesforce is dead until this succeeds.
export const storePdf = async ( pdfSettings, id, input ) => {
	const url = `${ pdfSettings.restUrl }pdfs/${ id }`;
	let response = await postJson( url, input );

	if ( ! response.ok && response.status !== 409 ) {
		response = await postJson( url, input );
	}

	// 409 = already stored, e.g. by the first attempt above.
	if ( ! response.ok && response.status !== 409 ) {
		throw new Error( `Storing the PDF failed (${ response.status })` );
	}
};

export const downloadPdf = async ( pdfSettings, input ) => {
	const response = await postJson( `${ pdfSettings.restUrl }pdf`, input );

	if ( ! response.ok ) {
		throw new Error( `Creating the PDF failed (${ response.status })` );
	}

	const objectUrl = window.URL.createObjectURL( await response.blob() );
	const link = document.createElement( 'a' );
	link.href = objectUrl;
	link.download = 'roi-calculation.pdf';
	document.body.appendChild( link );
	link.click();
	link.remove();
	window.URL.revokeObjectURL( objectUrl );
};

// "Already submitted the lead form" is remembered per calculator and
// browser, so returning visitors aren't asked again. Storage can be
// unavailable (private mode, blocked cookies) — then it just isn't
// remembered.
const leadStorageKey = ( calculatorId ) =>
	`sprintray-roi-calculator:lead-submitted:${ calculatorId }`;

export const hasSubmittedLead = ( calculatorId ) => {
	try {
		return (
			window.localStorage.getItem( leadStorageKey( calculatorId ) ) ===
			'1'
		);
	} catch {
		return false;
	}
};

export const rememberSubmittedLead = ( calculatorId ) => {
	try {
		window.localStorage.setItem( leadStorageKey( calculatorId ), '1' );
	} catch {}
};
